import actionCreator from '../../createAction';

const createAction = actionCreator('public');

export const LOAD_COMPARE = createAction('LOAD_COMPARE');

export const LOAD_DISCOUNT = createAction('LOAD_DISCOUNT');

export const UPDATE_CART = createAction('UPDATE_CART');

export const LOAD_BLOGS = createAction('LOAD_BLOGS');

export const GET_POST = createAction('GET_POST');

export const GET_ARTICLE = createAction('GET_ARTICLE');

export const UPDATE_USER_ARTICLE = createAction('UPDATE_USER_ARTICLE');
